import { TWclassNames } from "./Div";
import { sanitizeRichHtml } from "./sanitize-rich-html";
import "./PromangRichTextEditor.css";

/**
 * Normalize stored rich/plain description for HTML display.
 * - HTML from Quill is sanitized then shown (images and empty <p><br></p> kept)
 * - Legacy plain text (real newlines, no tags) is escaped and converted to <p>/<br>
 */
export function toDisplayRichHtml(value) {
  const raw = value == null ? "" : String(value);
  if (!raw.trim()) return "";

  // Quill / rich HTML — sanitize then keep spacing fixes.
  if (/<[a-z][\s\S]*>/i.test(raw)) {
    const safe = sanitizeRichHtml(raw);
    // Ensure empty paragraphs keep height when browsers collapse <p></p>.
    return safe.replace(/<p>(?:\s|&nbsp;)*<\/p>/gi, "<p><br></p>");
  }

  const escaped = raw
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

  return escaped
    .split(/\n{2,}/)
    .map((para) => `<p>${para.replace(/\n/g, "<br>")}</p>`)
    .join("");
}

/**
 * Renders stored plan/project rich-text HTML with Quill-compatible display styles
 * (paragraph spacing, lists, images, align classes).
 */
export function PromangRichTextContent({
  html,
  className,
  as: Component = "div",
  empty = null,
}) {
  const displayHtml = toDisplayRichHtml(html);
  if (!displayHtml) return empty;

  return (
    <Component
      className={TWclassNames(
        "promang-rich-text-content prose prose-sm max-w-none",
        className
      )}
      dangerouslySetInnerHTML={{ __html: displayHtml }}
    />
  );
}
